import React, { useEffect } from "react";
import { GrFormAdd } from "react-icons/gr";
import { useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { useContext } from "react";
export default function Sidebar() {
  const [studentName, setStudentName] = useState("");
  const [guardianNumber, setGuardianNumber] = useState("");
  const [studentRoll, setStudentRoll] = useState("");
  const [solWallet, setSolWallet] = useState("");

  const [className, setClassName] = useState("");

  const [currentTab, setCurrentTab] = useState("createClass");

  const handleClassClick = (tab) => () => setCurrentTab(tab);

  const [showAddStudent, setShowAddStudent] = useState(false);

  const [listOfClasses, setListOfClasses] = useState([]);
  const [currentActiveClass, setCurrentActiveClass] = useState("");

  const [studentInfo, setStudentInfo] = useState([]);
  const [loadingClasses, setLoadingClasses] = useState(false);
  const [loadingStudentInfo, setLoadingStudentInfo] = useState(false);

  const [filterListOfUsers, setFilterListOfUsers] = useState([]);

  const [detailsInfo, setDetailsInfo] = useState(null);
  const createClass = async () => {
    if (className === "") return toast.error("Class Name cannot be empty");
    const loadingToast = toast.loading("Creating Class...");
    //make request

    //check if class already exists
    if (listOfClasses.includes(className)) {
      toast.dismiss(loadingToast);
      return toast.error("Class already exists");
    }
    setListOfClasses([...listOfClasses, className]);

    toast.dismiss(loadingToast);
    toast.success("Class Created Successfully!");
    setClassName("");
  };

  const addStudent = async () => {
    //make post request to server
    if (studentName === "") return toast.error("Student Name cannot be empty");
    if (guardianNumber === "")
      return toast.error("Guardian Number cannot be empty");
    if (studentRoll === "") return toast.error("Student Roll cannot be empty");
    if (solWallet === "") return toast.error("Solana Wallet cannot be empty");

    const profileValue = JSON.parse(localStorage.getItem("profile"));
    const admin_email = profileValue.email;
    const admin_password = profileValue.password;
    const class_name = currentActiveClass;
    const student_roll = studentRoll;
    const student_name = studentName;
    const guardian_number = guardianNumber;
    const wallet_address = solWallet;

    const loadingToast = toast.loading("Adding Student...");

    const response = await fetch("https://tipdeso.com/add-student", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        admin_email,
        admin_password,
        class_name,
        student_roll,
        student_name,
        guardian_number,
        wallet_address,
      }),
    });
    const data = await response.json();
    if (data.status == "success") {
      toast.dismiss(loadingToast);
      toast.success("Student Added Successfully!");
      setStudentName("");
      setGuardianNumber("");
      setStudentRoll("");
      setSolWallet("");
      setShowAddStudent(false);

      setStudentInfo([
        ...studentInfo,
        {
          student_name: student_name,
          student_roll: student_roll,
          guardian_number: guardian_number,
          wallet_address: wallet_address,
        },
      ]);
      // setFilterListOfUsers(...filterListOfUsers, {
      //   student_name: student_name,
      //   student_roll: student_roll,
      //   guardian_number: guardian_number,
      //   wallet_address: wallet_address,
      // });

      const newValue = {
        name: student_name,
        student_roll: student_roll,
        guardian_number: guardian_number,
        wallet_address: wallet_address,
      };
      setFilterListOfUsers([...filterListOfUsers, newValue]);
    }
    console.log(data);
  };

  async function getDetailsOfUser(admin_email) {
    //make post request to server
    setLoadingClasses(true);
    const response = await fetch("https://tipdeso.com/get-details", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        admin_email,
      }),
    });

    const data = await response.json();
    console.log(data);
    if (data.status == "success") {
      setDetailsInfo(data.data);
      const dataVal = data.data;

      //loop through dataVal and get all classes
      const classesList = [];
      const classesMap = data.data.classes;
      for (const key in classesMap) {
        classesList.push(key);
      }
      setListOfClasses(classesList);

      //setStudentInfo(data.students);
    }
  }
  useEffect(() => {
    const profileValue = JSON.parse(localStorage.getItem("profile"));
    const admin_email = profileValue.email;

    getDetailsOfUser(admin_email);
  }, [currentActiveClass]);

  const deleteStudent = async (student_roll) => {
    const profileValue = JSON.parse(localStorage.getItem("profile"));
    const admin_email = profileValue.email;
    const class_name = currentActiveClass;
    const roll_number = student_roll;
    const admin_password = profileValue.password;

    const loadingToast = toast.loading("Deleteing Student...")
    const response = await fetch("https://tipdeso.com/delete-student", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        admin_email,
        admin_password,
        class_name,
        student_roll
      }),

    
    });
    if(response.status=== "success"){
      toast.dismiss(loadingToast);
      toast.success("Student Deleted Successfully!");
      try{
        setFilterListOfUsers(filterListOfUsers.filter((item) => item.student_roll !== student_roll));
      }
      catch{
        console.log("error")
      }

    }
    
    ///todo have to do
  };
  const handleFilter = (className) => {
    setCurrentActiveClass(className);

    const dataVal = detailsInfo;
    const classesTemp = dataVal.classes[className];
    console.log(classesTemp);

    //LOOP THOURGH CLASSES TEMP
    const studentsList = [];
    for (const key in classesTemp) {
      const rollVal = classesTemp[key];
      if (rollVal != null) {
        let tempMpa = classesTemp[key];
        tempMpa["student_roll"] = key;
        studentsList.push(tempMpa);
      }
    }
    setFilterListOfUsers(studentsList);
  };
  return (
    <div className="flex">
      <Toaster />
      <div className=" flex-col h-screen p-3 bg-white shadow w-60 hidden sm:flex">
        <div className="space-y-3">
          <div className="flex-1">
            <ul className="pt-2 pb-4 space-y-1 text-sm">
              <li className=" bg-gray-100 hover:bg-gray-200 rounded-lg mb-10">
                <button
                  onClick={() => {
                    setCurrentTab("createClass");
                  }}
                  className="text-lg  px-3 py-2"
                >
                  Create Class
                  <GrFormAdd
                    className="inline-block ml-2 "
                    size={30}
                    color="#ffffff"
                  />
                </button>
              </li>
              <li className="my-4 text-base px-2 ">
                {" "}
                {listOfClasses.length === 0
                  ? "No Classes found"
                  : "All Classes"}
              </li>
              {/* <li className="">
                
              </li> */}
              {listOfClasses.map((item, index) => {
                return (
                  <button
                    key={index}
                    className={`text-lg  px-3 py-2 hover:bg-gray-200 rounded-lg w-full text-start ${
                      currentActiveClass === item ? "bg-gray-200" : ""
                    }`}
                    onClick={() => {
                      setCurrentTab("class");
                      handleFilter(item);
                    }}
                  >
                    {item}
                  </button>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      <div className="container mx-auto mt-12 sm:pl-2  ">
        {/* Show stuffs based on tabs */}
        {currentTab === "createClass" && (
          <div className="flex flex-col mt-3 items-center ">
            <div className="relative text-4xl  font-bold text-gray-800 text-center  leading-normal rounded-full z-10">
              <p className="mb-3">
                Create{" "}
                <span className="font-extrabold text-purple-800 decoration-purple-800 underline-offset-8 underline">
                  Class
                </span>{" "}
                for your Institution
              </p>
            </div>

            <div className="flex flex-col space-y-4">
              <input
                type="text"
                placeholder="Enter Class Name"
                value={className}
                onChange={(e) => setClassName(e.target.value)}
                className="border-2  rounded-md px-4 py-2 sm:w-96 focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
              />
            </div>

            <button
              className="bg-purple-800 text-white px-8 py-3 rounded-md hover:bg-purple-900 mt-2"
              onClick={createClass}
            >
              Create Class
            </button>
            <div className="mt-2">
              <p>
                Class could be anything that defines your Institution levels.
              </p>
            </div>
          </div>
        )}

        {currentTab === "class" && (
          <div className="flex flex-col mt-3 items-center ">
            {!showAddStudent && (
              <div>
                <p className="text-4xl font-bold text-gray-800 text-center  leading-normal rounded-full z-10">
                  Add Student in this class
                </p>
                <button
                  onClick={() => {
                    setShowAddStudent(true);
                  }}
                  className="text-lg  px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg"
                >
                  Add Student
                  <GrFormAdd
                    className="inline-block ml-2 "
                    size={30}
                    color="#ffffff"
                  />
                </button>
                <button
                  onClick={() => {
                    // setShowAddStudent(true);
                    toast.error("Attendance part isn't yet integrated in frontend.")
                  }}
                  className="text-lg ml-1 px-3 py-2 bg-purple-600 text-white hover:bg-purple-700 rounded-lg"
                >
                  Take Attendance
                </button>
              </div>
            )}

            {showAddStudent && (
              <div className="flex flex-col mt-3 items-center ">
                <div className="relative text-4xl  font-bold text-gray-800 text-center  leading-normal rounded-full z-10">
                  <p className="mb-3">
                    Add{" "}
                    <span className="font-extrabold text-purple-800 decoration-purple-800 underline-offset-8 underline">
                      Student
                    </span>{" "}
                    to Class 1
                  </p>
                </div>

                <div className="flex flex-col space-y-2">
                  <p>Student Name:</p>
                  <input
                    type="text"
                    placeholder="Student Name"
                    value={studentName}
                    onChange={(e) => setStudentName(e.target.value)}
                    className="border-2  rounded-md px-4 py-2 sm:w-96 focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                  />

                  <p>Student Roll Number:</p>
                  <input
                    type="text"
                    placeholder="Roll Number"
                    value={studentRoll}
                    onChange={(e) => setStudentRoll(e.target.value)}
                    className="border-2  rounded-md px-4 py-2 sm:w-96 focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                  />

                  <p>Guardian's Phone number for notifications:</p>
                  <input
                    type="text"
                    placeholder="Guardian's Phone Number"
                    value={guardianNumber}
                    onChange={(e) => setGuardianNumber(e.target.value)}
                    className="border-2  rounded-md px-4 py-2 sm:w-96 focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                  />

                  <p> Solana Wallet Address to received streak prizes</p>
                  <input
                    type="text"
                    placeholder="Solana Wallet Address"
                    value={solWallet}
                    onChange={(e) => setSolWallet(e.target.value)}
                    className="border-2  rounded-md px-4 py-2 sm:w-96 focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                  />
                </div>
                <div className="flex justify-end space-x-2 mt-3 items-end">
                  <button
                    className="bg-purple-800 text-white px-8 py-3 rounded-md hover:bg-purple-900"
                    onClick={addStudent}
                  >
                    Add Student
                  </button>
                  <button
                    className="bg-red-500 text-white px-8 py-3 rounded-md hover:bg-red-600 "
                    onClick={() => {
                      setShowAddStudent(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            <p className="text-xl font-bold text-gray-800 text-center  leading-normal rounded-full z-10 mt-8">
              List of Students in this Class
            </p>

            <table className="table-auto w-full px-1 mt-3">
              <thead>
                <tr className="">
                  <th className="text-start">Roll No.</th>
                  <th className="text-start">Student Name</th>
                  <th className="text-start">Guardian's contact</th>
                  <th className="text-start">Wallet Address</th>
                  <th className="text-start">{""}</th>
                </tr>
              </thead>
              <tbody>
                {filterListOfUsers.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.student_roll}</td>
                      <td>{item.name}</td>
                      <td>{item.guardian_number}</td>
                      <td>{item.wallet_address}</td>
                      <td>
                        <button
                          className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600"
                          onClick={() => {
                            deleteStudent(item.rollNumber);
                          }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
